var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.user && _vm.user.achievements)?_c('span',{attrs:{"title":"ELO Rating"}},[_c('i',{staticClass:"fas fa-chess-knight me-1"}),_vm._v(_vm._s(_vm.user.achievements.eloRating || 1200))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }